import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import configurations from './modules/configurations'
import performance from './modules/performance'
import device from './modules/device'

import login from '@/services/login'
import { Device } from '@/services/device'

// Utility functions
import { set } from '@/utils'

Vue.use(Vuex)

// Default snackbar props
const resetToast = () => ({
  show: false,
  message: 'This is a toast',
  duration: 3000,
  color: '#4CAF5',
  x: '',
  y: 'bottom',
  mode: 'multi-line',
  classes: ''
})

const state = {
  isApiUp: false,
  loading: false,
  isNavBarClose: true,
  confirmationModal: {
    show: false,
    title: 'This is Custom title',
    subTitle: 'This is sample title',
    cancelButtonLabel: 'No',
    confirmButtonLabel: 'Yes',
    onClick: () => {}
  },
  toast: resetToast(),
  enableSearch: false,
  hideFeedbackButton: false,
  feedbackReasons: [],
  idleTime: 100 * 60 * 1000 // Defalut 1 min time in milli seconds
}

const modules = {
  common,
  configurations,
  device,
  performance
}

const getters = {
  isApiUp: state => state.isApiUp,
  loading: state => state.loading,
  isNavBarClose: state => state.isNavBarClose,
  confirmationModal: state => state.confirmationModal,
  enableSearch: state => state.enableSearch,
  hideFeedbackButton: state => state.hideFeedbackButton,
  feedbackReasons: state => state.feedbackReasons,
  toast: state => state.toast,
  idleTime: state => state.idleTime
}

const mutations = {
  setSingleProperty: (state, [prop, value]) => {
    state[prop] = value
  },

  setConfirmationModalObj: (state, confirmationModalObj) => {
    set(state.confirmationModal, confirmationModalObj)
  },

  resetToast: (state) => {
    state.toast = resetToast()
  }
}

const actions = {
  setSingleProperty({ commit }, [prop, value]) {
    commit('setSingleProperty', [prop, value])
  },
  setApiStatus({ commit }, status) {
    commit('setSingleProperty', ['isApiUp', status])
  },
  setLoader({ commit }, status) {
    commit('setSingleProperty', ['loading', status])
  },
  setNavBarOpenStatus({ commit }, status) {
    commit('setSingleProperty', ['isNavBarClose', status])
  },
  resetToast({ commit }) {
    commit('resetToast')
  },
  async fetchFeedbackReasons({ commit }) {
    const reasons = await Device.getAlertFeedbackReasons()
    commit('setSingleProperty', ['feedbackReasons', reasons])
  },
  loginToApp({ commit }, object = { loginParams: {}, callback: () => {} }) {
    return login(object.loginParams).then((data) => object.callback(data))
  },
  /**
   * Set the confirmation modal object, which triggers the confirmation modal to open and populate with the specified
   * description, buttons, and on click action
   * @param commit
   * @param title {string}
   * @param onClick {function}
   * @param cancelButtonLabel {string}
   * @param confirmButtonLabel  {string}
   */
  setConfirmationModal({ commit }, { title = '', subTitle = '', onClick = () => {}, cancelButtonLabel = 'No', confirmButtonLabel = 'Yes' }) {
    commit('setConfirmationModalObj', {
      show: true,
      title,
      subTitle,
      onClick,
      cancelButtonLabel,
      confirmButtonLabel
    })
  },

  /**
   * Clear the confirmation modal object and ensure that the confirmation modal is hidden.
   * @param commit
   */
  clearConfirmationModal({ commit }) {
    commit('setConfirmationModalObj', {
      show: false,
      title: '',
      subTitle: '',
      onClick: () => {},
      cancelButtonLabel: 'No',
      confirmButtonLabel: 'Yes'
    })
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules
})
